import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import frTranslations from './locales/fr.json';

const resources = {
  en: {
    translation: enTranslations,
  },
  fr: {
    translation: frTranslations,
  },
};

/**
 * Where the language a person picked is kept. Only a pick goes there: what
 * the detector finds is never kept, so the app and the site follow the
 * phone's or the browser's language until someone chooses another.
 */
const CHOSEN_LANGUAGE_KEY = 'language';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: CHOSEN_LANGUAGE_KEY,
      caches: [],
    },
    parseMissingKeyHandler: (key) => {
      return `[⚠️ MISSING: ${key}]`;
    },
  });

/** Switches to the language the person picked, and keeps it for their next visits. */
export function chooseLanguage(code: string): void {
  void i18n.changeLanguage(code);

  try {
    localStorage.setItem(CHOSEN_LANGUAGE_KEY, code);
  } catch {
    // Storage refused (private browsing): the pick holds until the page closes.
  }
}

export default i18n;
